// Configuration
const TRIGGER_VARIANT_ID = 55917650510201;
const GIFT_VARIANT_ID = 56325264114041;

// Fonction pour ajouter le cadeau et forcer le recalcul
async function addGiftToCart(triggerVariantId, giftVariantId) {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    const hasTriggerProduct = cart.items.some(item => item.variant_id === triggerVariantId);
    const hasGift = cart.items.some(item => item.variant_id === giftVariantId);
    
    if (hasTriggerProduct && !hasGift) {
      // 1. Ajouter le cadeau
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: 1
          }]
        })
      });
      
      console.log('Cadeau ajouté');
      
      // 2. FORCER le recalcul du panier (CRITIQUE)
      await forceCartRecalculation();
      
      // 3. Rafraîchir l'affichage
      await refreshCartDisplay();
      
    } else if (!hasTriggerProduct && hasGift) {
      // Retirer le cadeau
      const giftItem = cart.items.find(item => item.variant_id === giftVariantId);
      if (giftItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
        
        await refreshCartDisplay();
        console.log('Cadeau retiré');
      }
    }
  } catch (error) {
    console.error('Erreur:', error);
  }
}

// Fonction pour forcer Shopify à recalculer les réductions automatiques
async function forceCartRecalculation() {
  try {
    // Méthode 1 : Faire un update vide pour déclencher le recalcul
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {} })
    });
    
    // Méthode 2 : Ajouter/retirer un attribut pour forcer le refresh
    const timestamp = Date.now();
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        attributes: { '_recalc': timestamp.toString() }
      })
    });
    
    console.log('Recalcul forcé');
  } catch (error) {
    console.error('Erreur recalcul:', error);
  }
}

// Fonction pour rafraîchir l'affichage
async function refreshCartDisplay() {
  // Attendre que Shopify recalcule (important!)
  await new Promise(resolve => setTimeout(resolve, 20));
  
  // Récupérer le panier mis à jour avec les prix recalculés
  const updatedCart = await fetch('/cart.js').then(r => r.json());
  console.log('Panier mis à jour:', updatedCart);
  
  // Méthode 1 : Event custom pour Dawn
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
    detail: { cart: updatedCart }
  }));
  
  // Méthode 2 : Recharger les sections du cart drawer
  const sections = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
    .then(r => r.json())
    .catch(() => ({}));
  
  if (sections['cart-drawer']) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      }
    }
  }
  
  // Méthode 3 : Mettre à jour le compteur
  if (sections['cart-icon-bubble']) {
    const bubble = document.querySelector('cart-icon-bubble');
    if (bubble) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const newBubble = doc.querySelector('cart-icon-bubble');
      if (newBubble) {
        bubble.innerHTML = newBubble.innerHTML;
      }
    }
  }
  
  // Fallback : fonction du thème
  if (typeof window.refreshCart === 'function') {
    window.refreshCart();
  }
}

// Intercepter les modifications du panier
document.addEventListener('DOMContentLoaded', () => {
  const originalFetch = window.fetch;
  
  window.fetch = function(...args) {
    const [url] = args;
    
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      return originalFetch.apply(this, args).then(async (response) => {
        const cloned = response.clone();
        
        // Attendre que la requête soit complète
        setTimeout(() => {
          addGiftToCart(TRIGGER_VARIANT_ID, GIFT_VARIANT_ID);
        }, 100);
        
        return cloned;
      });
    }
    
    return originalFetch.apply(this, args);
  };
  
  // Vérifier au chargement
  addGiftToCart(TRIGGER_VARIANT_ID, GIFT_VARIANT_ID);
});

// Écouter les événements du thème
document.addEventListener('cart:updated', () => {
  setTimeout(() => {
    addGiftToCart(TRIGGER_VARIANT_ID, GIFT_VARIANT_ID);
  }, 500);
});